import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Building2 } from "lucide-react";
import { t } from "@/i18n/sk";
import { COMPANY } from "@/lib/company";
import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="relative mt-24 border-t border-white/8 bg-vault-black">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div>
          <Logo testId="footer-logo" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">{t.footer.tagline}</p>
        </div>

        <div>
          <h4 className="overline mb-4">{t.footer.shop}</h4>
          <ul className="flex flex-col gap-3 text-sm text-slate-400">
            <li><Link to="/serie" className="transition-colors hover:text-cyan-300">{t.nav.series}</Link></li>
            <li><Link to="/etb-boxy" className="transition-colors hover:text-cyan-300">{t.nav.etb}</Link></li>
            <li><Link to="/boostre" className="transition-colors hover:text-cyan-300">{t.nav.boosters}</Link></li>
            <li><Link to="/karty" className="transition-colors hover:text-cyan-300">{t.nav.cards}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4">{t.footer.info}</h4>
          <ul className="flex flex-col gap-3 text-sm text-slate-400">
            <li><Link to="/doprava-a-platba" data-testid="footer-link-shipping" className="transition-colors hover:text-cyan-300">{t.footer.policies.shipping}</Link></li>
            <li><Link to="/vratenie-tovaru" data-testid="footer-link-returns" className="transition-colors hover:text-cyan-300">{t.footer.policies.returns}</Link></li>
            <li><Link to="/obchodne-podmienky" data-testid="footer-link-terms" className="transition-colors hover:text-cyan-300">{t.footer.policies.terms}</Link></li>
            <li><Link to="/ochrana-osobnych-udajov" data-testid="footer-link-privacy" className="transition-colors hover:text-cyan-300">{t.footer.policies.privacy}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4">{t.footer.contact}</h4>
          <ul className="flex flex-col gap-3 text-sm text-slate-400">
            <li className="flex items-start gap-2"><Building2 className="mt-0.5 h-4 w-4 shrink-0 text-violet-300" /> <span>{COMPANY.name}<br />IČO {COMPANY.ico}</span></li>
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-violet-300" /> <span>{COMPANY.street}<br />{COMPANY.cityZip}</span></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-violet-300" /> {COMPANY.email}</li>
            <li className="flex items-center gap-2" data-testid="footer-phone"><Phone className="h-4 w-4 text-violet-300" /> {COMPANY.phone}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/8">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <p className="text-xs leading-relaxed text-slate-500">{t.footer.disclaimer}</p>
          <p className="mt-3 text-xs text-slate-600">© {new Date().getFullYear()} {COMPANY.shop} · {COMPANY.name} {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
